/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteMemberInternalV2MembersOrgIdDelete$Params {
  org_id: string;
  org: string;
}

export function deleteMemberInternalV2MembersOrgIdDelete(http: HttpClient, rootUrl: string, params: DeleteMemberInternalV2MembersOrgIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteMemberInternalV2MembersOrgIdDelete.PATH, 'delete');
  if (params) {
    rb.path('org_id', params.org_id, {});
    rb.query('org', params.org, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteMemberInternalV2MembersOrgIdDelete.PATH = '/_internal/v2/members/{org_id}';
